import React, { useEffect, useState } from 'react';
import TextInput from './UTMFields/TextInput.js';
import SelectInput from './UTMFields/SelectInput.js';
import UTMBuilder from './UTMFields/UTMBuilder.js';
import ActionOptions from './UTMFields/ActionOptions.js';
import DatePicker from '../DatePicker';

// Default Config Variables for DatePicker Input
const oneDay = 60 * 60 * 24 * 1000;
const todayTimestamp =
  Date.now() -
  (Date.now() % oneDay) +
  new Date().getTimezoneOffset() * 1000 * 60;

export default function DetailItem({
  item,
  updateUTMList,
  newUTMList,
  configs
}) {
  const [formData, updateFormData] = useState({
    id: item.id,
    destinationUrl: item.destinationUrl,
    campaign: item.campaign,
    date: item.date,
    medium: item.medium,
    source: item.source,
    content: item.content,
    keyword: item.keyword,
    utm_codes: item.utm_codes
  });

  const {
    destinationUrl,
    campaign,
    medium,
    source,
    content,
    keyword,
    date
  } = formData;

  useEffect(() => {
    let newState = [...newUTMList];
    const index = newState.findIndex((item) => item.id === formData.id);
    newState[index] = formData;
    updateUTMList(newState);
  }, [formData]);

  return (
    <div className="">
      <div className="utm__inputs u--display-flex">
        <TextInput
          curValue={destinationUrl}
          updateValue={updateFormData}
          formData={formData}
          category="destinationUrl"
          colSize={2}
          placeholder="URL"
        />
        <SelectInput
          curValue={campaign}
          updateValue={updateFormData}
          formData={formData}
          category="campaign"
          colSize={2}
          config={configs.campaign}
        />
        <SelectInput
          curValue={medium}
          updateValue={updateFormData}
          formData={formData}
          category="medium"
          colSize={2}
          config={configs.medium}
        />
        <SelectInput
          curValue={source}
          updateValue={updateFormData}
          formData={formData}
          category="source"
          colSize={2}
          config={configs.source}
        />
        <DatePicker
          initialDate={date ? date : todayTimestamp}
          disabled={date ? false : true}
          onChange={(timestamp) => {
            updateFormData((state) => ({ ...state, date: timestamp }));
          }}
        />
        <TextInput
          curValue={content}
          updateValue={updateFormData}
          formData={formData}
          category="content"
          colSize={1}
        />
        <TextInput
          curValue={keyword}
          updateValue={updateFormData}
          formData={formData}
          category="keyword"
          colSize={1}
        />
        <ActionOptions
          curUTM={item}
          updateUTMList={updateUTMList}
          curList={newUTMList}
        />
      </div>
      <div className="u--height-40">
        <UTMBuilder formData={formData} updateValue={updateFormData} />
      </div>
    </div>
  );
}
